import React, { Component } from 'react';

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      term: ''
    };
  }

  onInputChange(term) {
    this.setState(() => {
      return { term };
    });
    this.props.onSearchTermChange(term);
  }

  render() {
    return (
      <div className="SearchBar">
        <input
          type="text"
          name="search"
          value={this.state.term}
          autoComplete="off"
          autoFocus="true"
          onChange={event => this.onInputChange(event.target.value)}
          className="col-md-12"
        />
      </div>
    );
  }
}

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/SearchBar.js